import oc from '../../assets/about/execs/oc.png';
import vcEvents1 from '../../assets/about/execs/vce1.png';
import vcEvents2 from '../../assets/about/execs/vce2.png';
import vcFinance from '../../assets/about/execs/vcf.png';
import vcLeadership1 from '../../assets/about/execs/vcl1.png';
import vcLeadership2 from '../../assets/about/execs/vcl2.png';
import vcMarketing from '../../assets/about/execs/vcm.png';
import vcRelations from '../../assets/about/execs/vcr.png';

export const execInfo = {
  ocs: [
    {
      name: 'Simona Tenche',
      role: 'Orientation Chair',
      discipline: 'MSE 2T6 + PEY',
      image: oc,
      description: `i’m an mse 2t6 (previously engsci) and i love all things space and sustainability! i love reading, theatre, baking, and anything to do with cats, matcha, coffee, and cheese. you might recognize me from being hhc manager last year, working at engstores, or helping out with every event on the planet, but this year im so excited to be your oc!

    `,
    },
  ],
  vcs: [
    {
      name: 'Justin Fang',
      role: 'VC Finance',
      discipline: 'ECE 2T7',
      image: vcFinance,
      description: `Some quick fun facts about me: I transferred from civil engineering to computer engineering based on 1 course (APS106), I like to listen to a lot of music (250k mins/year) and I love playing hockey! In my spare time, I like to play video games (league, val) or run events. Broo y’all should come to F!rosh Week because I heard the merch this year is chefs kiss. Also find me during F!rosh Week for a surprise (more merch?) You’ll have to sign up for F!rosh Week and find out!`,
    },
    {
      name: 'Bhoovi R. Handa',
      role: 'VC Leadership',
      discipline: 'Indy 2T6 + PEY',
      image: vcLeadership1,
      description: `Sad to report that once again, my brain went 💨 and I asked ChatGPT for help. *Update... it was useless.*
  ⏩ Real quick fact recap: reading 📚, fashion 👗, martial arts 🥊, yapping, 💛yncn 🐧, and 🎤💃 everything creative 🎞️🎬🖋️
  Side note: cancel your plans last week of August—you’re coming to F!rosh Week 2T5.`,
    },
    {
      name: 'Sebastian Dot',
      role: 'VC Leadership',
      discipline: 'Chem 2T6 + PEY',
      image: vcLeadership2,
      description: `From scrutinizing nutrition labels (it’s bulking season) to jumping out of airplanes at 10,000 ft, you can catch me doing just about anything. I’m a massive admirer of Chopin (I taught myself piano just to play his pieces) and a hypercompetitive person. I’m passionate about men’s traditional fashion, and I dabble in astrophotography, boxing, cycling, and paintball. Chances are you’ve seen me around, so feel free to say hi to talk about Chem Eng, research, music—or challenge me to a game of Speed or Slapjack!
  P.S. I BETTER see you this F!rosh Week—it’s gonna be the best one to date!`,
    },
    {
      name: 'Carl Ancheta',
      role: 'VC Marketing',
      discipline: 'EngSci (Machine Intelligence) 2T5 + PEY',
      image: vcMarketing,
      description: `When I’m not working (or not studying during the Skule™ year), you’ll catch me with a camera 📸 or doing graphic design (peep: Skulebook, Skule™ Agenda, Frosh Handbook, F!rosh photo, etc). I also love to bake (latest recipe: macarons!), am a dad to a growing army of succulents, and my favourite colour is teal (or any word/🔷hex code🟩 variation of it). I play video games when I can find the time (it’s not *just* a theme for me).
  Bonus fun fact: this is my FIFTH F!rosh Week—I’ve collected many shirt colours in my time.`,
    },
    {
      name: 'Jenn Xu',
      role: 'VC Relations',
      discipline: 'Chem 2T6 + PEY',
      image: vcRelations,
      description: `I rotate between doing 3 things: 1. Rot 2. Graphics 3. More graphics. Big fan of being whimsical, jovial, and keeping myself so busy I can’t spiral. In all seriousness, I love singing, writing, watching anime, art history, and doing Eng research.
  Let’s go Chem Eng!`,
    },
    {
      name: 'Lesley Ha Tchong',
      role: 'VC Events',
      discipline: 'Chem 2T7 + PEY',
      image: vcEvents1,
      description: `I’m from Niagara Falls, which might explain my love for the water! I can’t take care of plants (my orchid died in one week), I can type 100 words per minute, I enjoy dabbling in robotics, I love the smell of garages and rosemary, and if I wasn’t in engineering, I’d be a chef. #yeschef
  Can’t wait for you to experience some amazing Frosh events this year!`,
    },
    {
      name: 'Nicholas Saldanha',
      role: 'VC Events',
      discipline: 'MSE 2T5 + 1 + PEY',
      image: vcEvents2,
      description: `Some fun facts about me: I’ve (technically) completed the F!rosh Week trifecta—subcom co-chair (DTW 2T2, 2T4; CT 2T3), HL (Lambda 2T4), and exec (VCE 2T5)! Outside of F!rosh, I’m a diehard baseball and Blue Jays fan. I also enjoy nature, camping, chatting with my buddies, and playing competitive video games.
  Looking forward to facilitating some of your events this F!rosh Week 😁`,
    },
  ],
};
